import { render, staticRenderFns } from "./AdminDriverDetails.vue?vue&type=template&id=8f65498c&scoped=true"
import script from "./AdminDriverDetails.vue?vue&type=script&lang=js"
export * from "./AdminDriverDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminDriverDetails.vue?vue&type=style&index=0&id=8f65498c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f65498c",
  null
  
)

export default component.exports